import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { EntityName } from 'record-it-time-common/EntityName';
import { Utils } from 'record-it-utils/utils/Utils/Utils';
import { UserRepository } from '../../../classes/entities/User/UserRepository';
import { User } from '../../../classes/entities/User/userTypes';
import { UserGroupRepository } from '../../../classes/entities/UserGroup/UserGroupRepository';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { UserGroupToUserRepository } from '../../../classes/entities/UserGroupToUser/UserGroupToUserRepository';
import { AuthenticationData } from '../../../context/AuthenticationContext';
import { useEntityChangedListener } from '../../entity/useEntityChangedListener/useEntityChangedListener';
import { useEntityRepository } from '../../entity/useEntityRepository';
export function useCurrentUserData(authenticationData) {
  const $ = _c(22);
  const userRepository = useEntityRepository(EntityName.User);
  const userGroupRepository = useEntityRepository(EntityName.UserGroup);
  const userGroupToUserRepository = useEntityRepository(EntityName.UserGroupToUser);
  let t0;
  if ($[0] !== authenticationData || $[1] !== userGroupRepository || $[2] !== userGroupToUserRepository || $[3] !== userRepository) {
    t0 = () => generateCurrentUserData({
      userRepository,
      userGroupRepository,
      userGroupToUserRepository,
      authenticationData
    });
    $[0] = authenticationData;
    $[1] = userGroupRepository;
    $[2] = userGroupToUserRepository;
    $[3] = userRepository;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const [currentUserData, setCurrentUserData] = useState(t0);
  let t1;
  if ($[5] !== userGroupRepository || $[6] !== userGroupToUserRepository || $[7] !== userRepository) {
    t1 = authData => {
      const newData = generateCurrentUserData({
        userRepository,
        userGroupRepository,
        userGroupToUserRepository,
        authenticationData: authData
      });
      setCurrentUserData(oldData => {
        if (Utils.isDeepEqual(newData, oldData)) {
          return oldData;
        }
        return newData;
      });
    };
    $[5] = userGroupRepository;
    $[6] = userGroupToUserRepository;
    $[7] = userRepository;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const updateCurrentUserData = useEventCallback(t1);
  let t2;
  let t3;
  if ($[9] !== authenticationData || $[10] !== updateCurrentUserData) {
    t2 = () => {
      updateCurrentUserData(authenticationData);
    };
    t3 = [updateCurrentUserData, authenticationData];
    $[9] = authenticationData;
    $[10] = updateCurrentUserData;
    $[11] = t2;
    $[12] = t3;
  } else {
    t2 = $[11];
    t3 = $[12];
  }
  useEffect(t2, t3);
  let t4;
  if ($[13] !== authenticationData || $[14] !== updateCurrentUserData) {
    t4 = () => {
      updateCurrentUserData(authenticationData);
    };
    $[13] = authenticationData;
    $[14] = updateCurrentUserData;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  useEntityChangedListener(EntityName.User, t4);
  let t5;
  if ($[16] !== authenticationData || $[17] !== updateCurrentUserData) {
    t5 = () => {
      updateCurrentUserData(authenticationData);
    };
    $[16] = authenticationData;
    $[17] = updateCurrentUserData;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  useEntityChangedListener(EntityName.UserGroup, t5);
  let t6;
  if ($[19] !== authenticationData || $[20] !== updateCurrentUserData) {
    t6 = () => {
      updateCurrentUserData(authenticationData);
    };
    $[19] = authenticationData;
    $[20] = updateCurrentUserData;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  useEntityChangedListener(EntityName.UserGroupToUser, t6);
  return currentUserData;
}
function generateCurrentUserData({
  userRepository,
  userGroupRepository,
  userGroupToUserRepository,
  authenticationData
}: GenerateCurrentUserDataOptions): CurrentUserData | null {
  const user = authenticationData ? userRepository.getById(authenticationData.userId) : null;
  if (!user) {
    return null;
  }
  const adminUserGroups: Array<UserGroup> = [];
  const userGroups: Array<UserGroup> = [];
  const userRelations = userGroupToUserRepository.getByUserId(user.id);
  for (const relation of userRelations) {
    const userGroup = userGroupRepository.getById(relation.ownerUserGroupId);
    if (!userGroup) {
      continue;
    }
    userGroups.push(userGroup);
    if (relation.groupAdmin) {
      adminUserGroups.push(userGroup);
    }
  }
  return {
    user,
    adminUserGroups,
    userGroups
  };
}
export type CurrentUserData = {
  user: User;
  userGroups: Array<UserGroup>;
  adminUserGroups: Array<UserGroup>;
};
type GenerateCurrentUserDataOptions = {
  userRepository: UserRepository;
  userGroupRepository: UserGroupRepository;
  userGroupToUserRepository: UserGroupToUserRepository;
  authenticationData: AuthenticationData | null;
};